import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { SmartDiaryEntry } from 'modules/smartDiary/smartDiaryNotes';
import { TimeSignal } from 'graphql/types';
import { useNotesBackgroudTimerContext } from '../context/NotesBackgroudTimerContext';

export const useSmartDiaryActiveTimer = (
  smartEntries: SmartDiaryEntry[]
): boolean => {
  const {
    running: isBackgroundTimerRunning,
    signalId
  } = useNotesBackgroudTimerContext();
  const { getValues } = useFormContext();
  const formValues = getValues();
  const smartDiaryActiveTimer = smartEntries.find(
    (smartEntry: SmartDiaryEntry) => {
      if (formValues[smartEntry.id]) {
        const matchedTimesignal = smartEntry?.timeSignals?.find(
          (timeSignal: TimeSignal) =>
            timeSignal?.id === signalId && isBackgroundTimerRunning
        );
        return matchedTimesignal;
      }
    }
  );
  return useMemo(() => Boolean(smartDiaryActiveTimer), [smartDiaryActiveTimer]);
};
